<template>
  <div>
    <ts-dialog title="Edit production step" :visible.sync="visible" width="500px" center :show-close="false">
      <ts-form-item :validation="$v.form.name">
        <ts-input placeholder="Step title" v-model.lazy="$v.form.name.$model"></ts-input>
      </ts-form-item>
      <ts-form-item :validation="$v.form.url">
        <ts-input placeholder="Link" v-model.lazy="$v.form.url.$model"></ts-input>
      </ts-form-item>
      <div class="user-picker">
        <p class="label">Users</p>
        <UserPicker :options="users" v-model.lazy="$v.form.users.$model" />
      </div>
      <span slot="footer">
        <div class="footer">
          <ts-button @click="handleSaveClick">Save</ts-button>
        </div>
      </span>
    </ts-dialog>
    <ts-button size="small" circle @click="handleOpenPickerButtonClick">
      <ts-icon icon="pen" size="x-small" color="#6d7587" title="Edit" />
    </ts-button>
  </div>
</template>

<style lang="scss" scoped>
.user-picker {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;

  .label {
    font-family: Roboto;
    font-size: 16px;
    color: #000000;

    margin-right: 20px;
  }
}

.footer {
  padding-top: 12px;
}
</style>

<script>
import { required, url } from 'vuelidate/lib/validators';
import { cloneDeep } from 'lodash';

import UserPicker from '@/components/inputs/UserPicker.vue';

export default {
  components: {
    UserPicker
  },
  props: {
    users: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      form: cloneDeep(this.value)
    };
  },
  validations: {
    form: {
      name: {
        required
      },
      url: {
        required,
        url
      },
      users: {}
    }
  },
  methods: {
    handleSaveClick() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('input', this.form);
        this.visible = false;
      }
    },
    handleOpenPickerButtonClick() {
      this.form = cloneDeep(this.value);
      this.visible = true;
    }
  }
};
</script>
